import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  postCountdownLine: string;
  size?: 'lg' | 'sm';
}
const UNITS: {
  key: 'hours' | 'minutes' | 'seconds';
  label: string;
}[] = [{
  key: 'hours',
  label: 'HRS'
}, {
  key: 'minutes',
  label: 'MIN'
}, {
  key: 'seconds',
  label: 'SEC'
}];
export function Countdown({
  postCountdownLine,
  size = 'lg'
}: CountdownProps) {
  const time = useCountdown();
  if (time.expired) {
    return <p className="font-mono text-[13px] uppercase tracking-label text-brass" data-id="element-95" data-mp="3h0z5n4mkrv1a">
        {postCountdownLine}
      </p>;
  }
  const digitClass = size === 'lg' ? 'text-[44px] sm:text-[64px] leading-none' : 'text-[32px] sm:text-[44px] leading-none';
  return <div role="timer" aria-live="off" aria-label={`${time.hours} hours ${time.minutes} minutes ${time.seconds} seconds remaining`} className="flex items-end justify-center gap-3 sm:gap-5" data-id="element-96" data-mp="374vtr71x8i15">
      {UNITS.map((unit, index) => <React.Fragment key={unit.key} data-id="element-97" data-mp="y04xe63v9qs3" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" className={`font-mono text-brass/50 ${digitClass} pb-[2px]`} data-id="element-98" data-mp="t2d6nfeykaph">
              :
            </span>}
          <span className="flex flex-col items-center gap-1.5" data-id="element-99" data-mp="17sssmwf77mop">
            <span className={`font-mono font-medium text-brass tabular-nums ${digitClass}`} data-id="element-100" data-mp="12sewocqvg371">
              {time[unit.key]}
            </span>
            <span className="font-mono text-[10px] uppercase tracking-label text-paper/50" data-id="element-101" data-mp="a37oem1m7z8l">
              {unit.label}
            </span>
          </span>
        </React.Fragment>)}
    </div>;
}